import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";

interface OwnProps {
    title: string;
    statementNumber: string;
}

type Props = OwnProps;

const StatementPageTypeLink: React.FunctionComponent<Props> = ({ title, statementNumber }) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: "StatementDetailsPage",
            overrideTitle: title,
            queryString: `statementNumber=${statementNumber}`,
        },
    });
};

export default StatementPageTypeLink;
